import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

import "./assets/css/main.css";
import "./assets/css/tokens.css";

import PrimeVue from "primevue/config";
import "primeicons/primeicons.css";
import lara from "./presets/lara";

import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";

import Vue3EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";

import "choices.js/public/assets/styles/choices.min.css";

import { setupAxios } from "@/plugins/axios";
import { registerGlobalProperties } from "@/plugins/globals";

const app = createApp(App);

app.use(ToastPlugin);

const toast = app.config.globalProperties.$toast;

registerGlobalProperties(app);

setupAxios({
    store,
    router,
    toast,
});

app.component("EasyDataTable", Vue3EasyDataTable);

app.use(PrimeVue, {
    unstyled: false,
    ripple: true,
    theme: "lara-light-blue",
    darkTheme: "lara-dark-blue",
    inputStyle: "outlined",
    pt: lara,
});

app.use(store);
app.use(router);

app.mount("#app");
